












































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { IPartialTxAuditResult } from 'simple-apostille-v2';
import {
  Address, Account, TransactionHttp, TransactionGroup,
} from 'symbol-sdk';
import AppConfig from '@/libs/AppConfig';
import { CosignatureQR, QRCodeGenerator, TransactionQR } from 'symbol-qr-library';
import AMetadata from '@/models/AMetadata';

@Component({
  components: {
  },
})
export default class PartialResultComponet extends Vue {
  @Prop()
  public auditResult?: IPartialTxAuditResult;

  @Prop()
  public filename?: string;

  @Prop()
  public txHash?: string;

  @Prop({ required: true })
  public cosign!: (key: string) => void;

  @Prop()
  public metadatas?: AMetadata[];

  private cosignatoriesKey = '';

  private signerAddress = '';

  private cosignButtonDisable = true;

  private qrcode: CosignatureQR|undefined;

  private base64 = '';

  private networkType = AppConfig.networkType();

  private apiEndpoint = AppConfig.apiEndpoint();

  private genetationHash = AppConfig.generationHash();

  mounted() {
    const txHttp = new TransactionHttp(this.apiEndpoint);
    txHttp.getTransaction(this.txHash || '', TransactionGroup.Partial).subscribe((tx) => {
      console.log('tx', tx);
      this.qrcode = new CosignatureQR(tx, this.networkType, this.genetationHash);
      console.log('qr', this.qrcode);
      this.qrcode.toBase64().subscribe((x) => {
        this.base64 = x;
      });
    });
  }

  private signerAccount() {
    if (this.auditResult && this.auditResult.signer) {
      return this.auditResult.signer.plain();
    }
    return '';
  }

  private apostilleAccount() {
    if (this.auditResult && this.auditResult.apostilleAccount) {
      return this.auditResult.apostilleAccount.plain();
    }
    return '';
  }

  private apostilleAccountLink() {
    return `http://explorer.testnet.symboldev.network/accounts/${this.apostilleAccount()}`;
  }

  private signerLink() {
    return `http://explorer.testnet.symboldev.network/accounts/${this.signerAccount()}`;
  }

  private cosignatoriesLink(a: Address) {
    return `http://explorer.testnet.symboldev.network/accounts/${a.plain()}`;
  }

  private cosinatoryIcon(a: Address) {
    if (this.isSigned(a)) {
      return 'mdi-account-check';
    }
    return 'mdi-account-alert';
  }

  private isSigned(a: Address) {
    if (this.auditResult && this.auditResult.cosignatories && this.auditResult.signer) {
      if (a.plain() === this.auditResult.signer.plain()) {
        return true;
      }
      const plainAddress = this.plainAddresses(this.auditResult.cosignatories);
      return plainAddress.includes(a.plain());
    }
    return false;
  }

  private plainAddresses(addresses: Address[]) {
    const plainAddress: string[] = [];
    addresses.forEach((a) => {
      plainAddress.push(a.plain());
    });
    return plainAddress;
  }

  private onClickCosign() {
    this.cosign(this.cosignatoriesKey);
  }

  private onChangeCosinatorieskey() {
    const signerAccount = Account.createFromPrivateKey(this.cosignatoriesKey, this.networkType);
    this.signerAddress = signerAccount.address.pretty();
    this.cosignButtonDisable = false;
  }
}
